import React from 'react'
import {
  Box, RadioButtonWMO, Text,
} from '@usap/uicomponents'
import { Container, Heading, ChangeAnswerCTA, List } from '../style/FirstSelectReasonWMO.css'

const FirstSelectReasonWMO = props => {
  const { firstStep, onChangeReason, isDesktop } = props

  return (
    <Container>
      <Heading
        key={`${firstStep.id}-0`}
      >
       {firstStep.title} 
      </Heading>
      <List>
        <RadioButtonWMO
          value={firstStep.id}
          name={firstStep.id}
          checked
          readOnly
          custom
          label={(
            <Text size="small" margin={{ left: 'xsmall' }} style={{ fontSize: '14px', fontWeight: 500 }}>
              {firstStep.label}
            </Text>
          )}
        />
      </List>
      <ChangeAnswerCTA
        type="button"
        onClick={onChangeReason}
      >
        Change Answer
      </ChangeAnswerCTA>
    </Container>
  )
}

export default FirstSelectReasonWMO
